import * as Yup from 'yup';
import i18n from 'i18next';
import { emailRegExp, passwordRegExp } from 'globalutils/constants';

const isGsOrSpireon = () => {
  const serviceProvider = window.$environment?.SERVICE_PROVIDER;
  return serviceProvider === 'gs' || serviceProvider === 'spireon';
};

export const schema = Yup.object().shape({
  company: Yup.string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .test('len', i18n.t('common.atleast4chars'), (val) => val?.length > 3),
  dotNumber: Yup.string()
    .matches(
      isGsOrSpireon() ? /^[a-zA-Z0-9]+$/ : /^[0-9]*$/,
      isGsOrSpireon() 
        ? i18n.t('Please enter valid alphanumeric DOT number')
        : i18n.t('Please enter valid number')
    )
    .required(i18n.t('common.fieldRequiredMessage')),
  maintenanceMileage: Yup.string().matches(/^[0-9]*$/, i18n.t('Please enter valid number')),
  initialTrucks: Yup.string()
    .matches(/^((?!(0))[0-9]*)$/, i18n.t('Please enter valid number.'))
    .required(i18n.t('common.fieldRequiredMessage')),
  address: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  city: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  zipCode: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  companyPhone: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  firstName: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  lastName: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  email: Yup.string().matches(emailRegExp, i18n.t('common.emailValidationMessage')).required(i18n.t('common.fieldRequiredMessage')),
  userPhone: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  password: Yup.string()
    .matches(
      passwordRegExp,
      i18n.t(
        'Password must have at least an uppercase character, a lowercase character, a digit, a special character, at least 6 characters and at most 15 characters long.'
      )
    )
    .required(i18n.t('common.fieldRequiredMessage')),
  confirm_password: Yup.string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .oneOf([Yup.ref('password'), null], i18n.t('common.confirmPasswordMessage')),
  agree: Yup.boolean().required(i18n.t('common.fieldRequiredMessage')).oneOf([true], i18n.t('common.fieldRequiredMessage')),
  cardHolderName: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  state: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  brainTreeToken: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
});

export const initialValues = {
  company: '',
  dotNumber: '',
  initialTrucks: '',
  maintenancePeriod: { label: 1, value: 1 },
  maintenanceMileage: '',
  subscriptionTier: 'PRO',
  contractLength: 3,
  address: '',
  city: '',
  state: '',
  zipCode: '',
  companyPhone: '',
  firstName: '',
  lastName: '',
  email: '',
  userPhone: '',
  password: '',
  confirm_password: '',
  cardHolderName: '',
  agree: '',
  producerCode: '',
  brainTreeToken: '',
};

export const maintenancePeriod = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
  { label: 6, value: 6 },
  { label: 7, value: 7 },
  { label: 8, value: 8 },
  { label: 9, value: 9 },
  { label: 10, value: 10 },
  { label: 11, value: 11 },
  { label: 12, value: 12 },
];
